var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 47,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.189 6.179h-.596V4.874a2.242 2.242 0 0 0-2.24-2.24 2.242 2.242 0 0 0-2.24 2.24V6.18H8.988V4.874a2.242 2.242 0 0 0-2.24-2.24 2.242 2.242 0 0 0-2.24 2.24V6.18H3.91A3.662 3.662 0 0 0 .254 9.836v31.19a3.662 3.662 0 0 0 3.657 3.657H42.19a3.662 3.662 0 0 0 3.657-3.658V9.836A3.662 3.662 0 0 0 42.19 6.18Zm-3.431-1.305a.596.596 0 0 1 1.19 0v4.253a.596.596 0 0 1-1.19 0V4.874ZM6.747 4.28c.328 0 .595.267.595.595v4.253a.596.596 0 0 1-1.19 0V4.874c0-.328.267-.595.595-.595Zm35.442 38.76H3.91a2.016 2.016 0 0 1-2.013-2.014V14.203H35.81a.822.822 0 0 0 0-1.645H1.9V9.836c0-1.11.902-2.013 2.012-2.013h.596v1.304a2.242 2.242 0 0 0 2.24 2.24 2.242 2.242 0 0 0 2.24-2.24V7.823h28.127v1.304a2.242 2.242 0 0 0 2.24 2.24 2.242 2.242 0 0 0 2.24-2.24V7.823h.595c1.11 0 2.013.903 2.013 2.013v2.722h-1.304a.822.822 0 0 0 0 1.645h1.304v26.822c0 1.11-.903 2.013-2.013 2.013Z",
    fill: "url(#b)",
    stroke: "url(#c)",
    strokeWidth: 0.227
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.062 12.672h-1.418a.709.709 0 1 0 0 1.418h1.418a.709.709 0 0 0 0-1.418Z",
    fill: "url(#d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.84 34.725c0 .915-.454 1.373-1.363 1.373h-4.502c-.89 0-1.334-.458-1.334-1.373V31.26h2.208v2.908h2.783V28.39h-4.991l.24-7.315h6.854v1.968h-4.771l-.144 3.417h3.657c.909 0 1.363.455 1.363 1.363v6.902Z",
    fill: "url(#e)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 23.05,
    y1: 2.748,
    x2: 23.05,
    y2: 44.569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2275A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4FBD96"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 23.05,
    y1: 2.748,
    x2: 23.05,
    y2: 44.569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2275A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4FBD96"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 39.353,
    y1: 12.672,
    x2: 39.353,
    y2: 14.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2275A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4FBD96"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 22.294,
    y1: 16.098,
    x2: 22.294,
    y2: 37.268,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2275A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4FBD96"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.367 .977)",
    d: "M0 0h45.366v45.366H0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.2167d26fb8fe1002c0687b997413fe45.svg";
export { ForwardRef as ReactComponent };